import { Button, Grid, MenuItem, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import dayjs from 'dayjs'
import { memo, useContext, useCallback, useEffect, useState } from 'react'
import { GlobalContext } from '../../App'
import { metodoPrograma } from '../../components/api'
import { Controller, useForm } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'

const retornaLocalAtendimento = (u, idLocalAtendimento, dadosEdicao) => ({
  idCaixa: u?.[0],
  idLocalAtendimento: u?.[1] || idLocalAtendimento,
  dsHistorico: dadosEdicao?.[1] || '',
  dtLancamento: dadosEdicao?.[0]
    ? dayjs(dadosEdicao?.[0]).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD'),
  vlLancamento: dadosEdicao?.[5] || 0,
  idFormaPagamento: dadosEdicao?.[3][0] || '',
  tpLancamento: dadosEdicao?.[4][0] || 'E',
})

const Edicao = ({ dados, voltarCaixa, visualizaCaixa, dadosEdicao }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [listaFormaPagamento, setListaFormaPagamento] = useState([])

  const { control, watch, handleSubmit, register } = useForm({
    defaultValues: retornaLocalAtendimento(
      dados,
      localAtendimento[0],
      dadosEdicao,
    ),
  })
  const salva = async (values) => {
    const obj = {
      dtLancamento: values.dtLancamento
        ? dayjs(values.dtLancamento).format('YYYY-MM-DD HH:mm')
        : undefined,
      idLancamento: dadosEdicao?.[6] || undefined,
      ...values,
    }
    const res = await metodoPrograma(
      dadosEdicao?.[6] ? 'alteraLancamentoCaixa' : 'insereLancamentoCaixa',
      obj,
    )
    if (res.status) visualizaCaixa()
  }

  const listaFormas = useCallback(() => {
    metodoPrograma('listaFormaPagamento', {}).then((res) => {
      if (res.status) {
        setListaFormaPagamento(res.lista)
      }
    })
  }, [])

  useEffect(() => {
    if (dados[0]) {
      listaFormas()
    }
  }, [dados, listaFormas])

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <TextField
            {...register('dsHistorico')}
            name="dsHistorico"
            label="Descrição"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            {...register('tpLancamento')}
            value={watch('tpLancamento')}
            name="tpLancamento"
            label="Tipo"
            fullWidth
            margin="dense"
            variant="outlined"
            select
          >
            <MenuItem value={'E'}>Entrada</MenuItem>
            <MenuItem value={'S'}>Saída</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField
            {...register('idFormaPagamento')}
            value={watch('idFormaPagamento')}
            name="idFormaPagamento"
            label="Forma de Pagamento"
            fullWidth
            margin="dense"
            variant="outlined"
            select
          >
            {listaFormaPagamento.map((option) => (
              <MenuItem key={option[0]} value={option[0]}>
                {option[1]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            {...register('dtLancamento')}
            name="dtLancamento"
            value={watch('dtLancamento')}
            label="Data"
            fullWidth
            margin="dense"
            variant="outlined"
            type={'date'}
          />
        </Grid>
        <Grid item xs={4}>
          <Controller
            name="vlLancamento"
            control={control}
            render={({ field: { onChange, value } }) => (
              <NumericFormat
                value={value}
                onValueChange={(values) => {
                  onChange(values.floatValue)
                }}
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                decimalScale={2}
                fixedDecimalScale
                customInput={TextField}
                fullWidth
                label="Valor"
                variant="outlined"
                margin="dense"
              />
            )}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltarCaixa}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
